import * as React from 'react';
import classnames from 'classnames';
import { Icon } from '@grandvisionhq/icons';
import { useIntl } from '@grandvisionhq/state';

const CarouselNavigationChevron = /*#__PURE__*/ React.forwardRef(({ isDisabled , hasInverseColor , hasTopNavigation , onClick , direction  }, ref)=>{
    const { getLabel  } = useIntl();
    const labelKey = direction === 'left' ? 'common.actions.previous' : 'common.actions.next';
    return /*#__PURE__*/ React.createElement("button", {
        className: classnames(`carousel__navigation-chevron carousel__navigation-chevron--${direction}`, {
            disabled: isDisabled,
            inversed: hasInverseColor,
            [`carousel__navigation-chevron--top-${direction}`]: hasTopNavigation
        }),
        disabled: isDisabled,
        onClick: onClick,
        "aria-label": getLabel(labelKey),
        ref: ref
    }, /*#__PURE__*/ React.createElement(Icon, {
        name: `chevron-${direction}`
    }));
});

export { CarouselNavigationChevron };
//# sourceMappingURL=CarouselNavigationChevron.js.map
